import React from 'react';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/account/user/models';
import { CS_QNA_LIST_SORT_OPTION_MODEL } from '../../../../../store/modules/cs/qna/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { CS_QNA_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/csQnaConstants';
import columns from './columns';
import { useAccountUserCsQnaDetail } from './hooks';

const AccountUserDetailCsQnaInfo = (props) => {
  const { userId, isActive } = props;
  const { csQnaList, getList, downloadUserDetailCsQnaListExcel, pagination, sortOption, filterOption } =
    useAccountUserCsQnaDetail({ userId, isActive });
  const { list, totalCnt } = csQnaList;

  return (
    <div className="account-user-detail-content">
      <div className="account-user-detail-section">
        <div className="title">상품 문의 리스트</div>

        <div className="account-user-detail-section-content">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={list}
            totalCnt={totalCnt}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
              sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            isStriped={true}
            emptyText={CS_QNA_LIST_TABLE_EMPTY_TEXT}
            showPagination
            filterOption={filterOption}
            sortOption={sortOption}
            pagination={pagination}
            getList={getList}
            getExcelDownload={downloadUserDetailCsQnaListExcel}
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailCsQnaInfo;
